import React from 'react'

export default () => {
  return (
    <div>
      <h1 className="header">Expense Tracker</h1>
    </div>
  )
}
